import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import Box, { BoxProps } from 'ui-box';
import { defaultColors, defaultFills, Icon } from '../../npaper';
import { IContact } from '../../stores';

export interface IContactThumbnailProps extends BoxProps<any> {
  children?: never;
  showName?: boolean;
  contact?: IContact;
  noLink?: boolean;
}

export const ContactThumbnail: React.FC<IContactThumbnailProps> = ({
  showName = true,
  contact,
  noLink = false,
  ...props
}) => {
  return (
    <Box
      {...props}
      className={classNames(props.className, 'a')}
      is={noLink ? 'div' : Link}
      {...(noLink ? {} : { to: `/contacts/${contact ? contact.id : 'TODO'}` })}
      display="inline-flex"
      alignItems="center"
    >
      <Box
        width="20px"
        height="20px"
        backgroundColor={defaultColors.gray[100]}
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        fontSize={12}
        borderRadius="100%"
        flexShrink={0}
        marginRight={showName ? 4 : 0}
        overflow="hidden"
        position="relative"
      >
        <Icon
          icon="person"
          color={defaultFills.normal[500]}
          style={{ lineHeight: 0 }}
        />
        {contact && contact.thumbnail && (
          <img
            alt=""
            src={contact.thumbnail}
            onError={(e: any) => (e.target.style.display = 'none')}
            style={{
              objectFit: 'contain',
              width: '100%',
              height: '100%',
              position: 'absolute',
            }}
          />
        )}
      </Box>
      {showName && (
        <p className="elipsis">{contact ? contact.name : 'TODO CHANGE'}</p>
      )}
    </Box>
  );
};
